var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('event-head'),_c('div',{staticClass:"mt-3"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.personinfo,"header-cell-style":{
            color: '#fff',
            fontSize: '14px',
            height: '40px',
            width: '100%',
        }}},[_c('el-table-column',{attrs:{"type":"index","label":"序号","align":"center","width":"60"}}),_c('el-table-column',{attrs:{"prop":"date","label":"日期","align":"center"}}),_c('el-table-column',{attrs:{"prop":"saas","label":"SaaS订阅收入","align":"center"}}),_c('el-table-column',{attrs:{"prop":"Share","label":"合伙人分成收入","align":"center"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }